export default {
  token: 'eec8a9f93c4d66d1b892b5406201940f',
  debug: true
}
